module.exports = __webpack_public_path__ + "static/media/COMFORTAA-LIGHT.866333be.TTF";